import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import { ActionButton } from 'components/ModelButton';

import greenCarEletric from 'img/green-electric-car.svg';
import greenCarEletricFromTheBack from 'img/green-electric-car-from-the-back.svg';
import greenCarEletricSideways from 'img/green-electric-car-sideways.svg';
import iconDownload from 'img/arrow-download.svg';

import { Pillars, RowImg, SustainabilityReport, TextSustainability } from './styles';

export const Sustainability: React.FC = () => {

  const grennDeliveryData: any = useSelector((state: RootState | undefined) => state?.slider?.state);

  const handleSustainabilityReport = () => {

    if (grennDeliveryData?.sustainabilityReport)
      window.open(grennDeliveryData?.sustainabilityReport, '_blank');
  };

  return (
    <div
      className="d-flex flex-column w-100 max-w-lg-100 flex-1 px-0 mt-4"
      data-testid="slider-sustainability"
    >
      <TextSustainability>
        A Viveo tem a sustentabilidade como um pilar essencial do seu negócio e
        atua para que ela faça parte de todas as ações e tomadas de decisão,
        promovendo competitividade aliada ao protagonismo na transformação da cadeia valor.
      </TextSustainability>

      <TextSustainability >
        A Estratégia de Sustentabilidade da Viveo reforça o propósito e orienta o
        desejo da empresa de gerar valor compartilhado por meio do desenvolvimento de
        soluções sustentáveis para os desafios da sociedade, em particular do setor de saúde.
        Tal ambição está alinhada aos Objetivos de Desenvolvimento Sustentável (ODS)
        da Organização das Nações Unidas (ONU), à Carta Internacional dos Direitos Humanos e é
        direcionada pelo mapeamento e endereçamento dos temas materiais, organizados em Pilares de atuação.
      </TextSustainability>

      <Pillars>
        <TextSustainability padding="pb-1">
          Pilares de atuação
        </TextSustainability>

        <ul className="list-instructions">
          <li>Gestão Íntegra</li>
          <li>Desenvolvimento humano</li>
          <li>Ecoeficiência</li>
          <li>Soluções para a sustentabilidade</li>
        </ul>
      </Pillars >

      <TextSustainability>
        Com isso, temos o objetivo de reduzir a emissão de gases de efeito estufa,
        e contamos com um grupo de trabalho dedicado ao assunto de Logística Sustentável
        que busca planejar e executar iniciativas para redução de emissões na atividade logística.
      </TextSustainability>

      <img src={greenCarEletric} className="pt-2 pb-4" />

      <TextSustainability>
        Desta forma, além da realização do Inventário de Emissões, a Viveo investiu
        em inovação com a frota verde, adquirindo veículos 100% elétricos.
      </TextSustainability>

      <TextSustainability>
        A Companhia estuda a possibilidade de, nos próximos três anos,
        substituir o last mile (última milha) de toda frota de veículos que atende
        a Região Metropolitana São Paulo por veículos elétricos, reduzindo significativamente
        as emissões decorrentes do transporte de produtos.
      </TextSustainability>

      <RowImg className="grid-gap-2 pt-2 pb-5">
        <img src={greenCarEletricFromTheBack} width="100%" />
        <img src={greenCarEletricSideways} width="100%" />
      </RowImg>

      <TextSustainability>
        Em outra frente, toda a frota da área comercial da Viveo,
        que contempla aproximadamente 200 veículos, tornou-se objeto de uma parceria sustentável.
        A iniciativa consiste em neutralizar as emissões de GEE geradas nos contratos de locação
        por meio do plantio de árvores nativas no corredor de biodiversidade do Rio Araguaia,
        um dos maiores corredores de biodiversidade do mundo.
      </TextSustainability>

      <TextSustainability>
        Para saber mais sobre as iniciativas de Sustentabilidade da Viveo,
        faça o download do nosso relatório.
      </TextSustainability>

      <SustainabilityReport>
        <ActionButton
          img={iconDownload}
          textButton={grennDeliveryData?.sustainabilityButtonText}
          action={handleSustainabilityReport}
        />
      </SustainabilityReport>
    </div>
  );
};